/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { USER_PROFILE } from "./test-data/user.profile";
import {
    TOTAL_PROVENANCE,
    PROVENANCE_DETAIL,
} from "./test-data/trag.provenance";

const SERVICE_NAME = "TragProvenanceService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class TragProvenanceService {
    private static instance: TragProvenanceService;
    private constructor(props: any = {}) {}
    public static getInstance(props: any = {}): TragProvenanceService {
        if (!this.instance) {
            this.instance = new TragProvenanceService(props);
        }
        return this.instance;
    }

    async getTragProvenance(assetId: string, provenanceId: number) {
        log.info(`inside get trag service`, assetId, provenanceId);
        const _timeline = _.find(TOTAL_PROVENANCE, {
            assetId: assetId,
        });
        const _smTimeline = _timeline?.timeLine.map((item) => {
            return {
                data: [
                    {
                        tag: item?.key,
                        title: item?.label,
                        id: item?.id,
                    },
                ],
            };
        });
        const _provenance = _.find(PROVENANCE_DETAIL, {
            assetId: assetId,
        });
        log.info(`inside get timeline`, _timeline);
        const provenanceData = _.find(_provenance?.provenance, {
            idx: provenanceId,
        });
        log.info(`inside get provenance`, provenanceData);
        // const _found = _.find(USER_PROFILE, {
        //     userId: userId,
        // });
        if (provenanceData) {
            return {
                title: _timeline?.name,
                subTitle: _timeline?.subtitle,
                timeline: _timeline?.timeLine,
                provenanceData: provenanceData,
                smtimeline: _smTimeline,
            };
        }
    }
}
